/* ROOT — interactive density dial. Self-contained, supports multiple instances. */
(function () {
  function initDial(root) {
    var svg = root.querySelector('[data-scalp]');
    var slider = root.querySelector('[data-slider]');
    var covVal = root.querySelector('[data-cov]');
    var tagThin = root.querySelector('[data-thin]');
    var tagFull = root.querySelector('[data-full]');
    if (!svg || !slider) return;

    var N = 520, seed = 7;
    function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }

    var base = '<defs><radialGradient id="rSkin' + Math.random().toString(36).slice(2) + '" cx="50%" cy="35%" r="70%"><stop offset="0%" stop-color="#c9a986"/><stop offset="100%" stop-color="#9c8163"/></radialGradient></defs>';
    var gradId = base.match(/id="([^"]+)"/)[1];
    svg.insertAdjacentHTML('beforeend', base);
    svg.insertAdjacentHTML('beforeend', '<ellipse cx="160" cy="120" rx="150" ry="108" fill="url(#' + gradId + ')"/>');

    var strands = [];
    for (var i = 0; i < N; i++) {
      var a = rnd() * Math.PI * 2, r = Math.sqrt(rnd());
      var cx = 160 + Math.cos(a) * r * 140, cy = 118 + Math.sin(a) * r * 96;
      var len = 6 + rnd() * 9, ang = -Math.PI / 2 + (rnd() - 0.5) * 0.7;
      strands.push({ cx: cx, cy: cy, x2: cx + Math.cos(ang) * len, y2: cy + Math.sin(ang) * len, thr: rnd() });
    }
    var g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    svg.appendChild(g);
    var lines = strands.map(function (s) {
      var l = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      l.setAttribute('x1', s.cx.toFixed(1)); l.setAttribute('y1', s.cy.toFixed(1));
      l.setAttribute('x2', s.x2.toFixed(1)); l.setAttribute('y2', s.y2.toFixed(1));
      l.setAttribute('stroke', '#2b2015'); l.setAttribute('stroke-width', '1.5');
      l.setAttribute('stroke-linecap', 'round'); g.appendChild(l); return l;
    });

    function render(v) {
      var frac = v / 100;
      if (covVal) covVal.textContent = Math.round(22 + frac * 75);
      for (var i = 0; i < lines.length; i++) lines[i].style.opacity = strands[i].thr <= frac ? '1' : '0';
      slider.style.setProperty('--p', v + '%');
      if (tagThin && tagFull) {
        if (v < 45) { tagThin.classList.add('on'); tagFull.classList.remove('on'); }
        else { tagThin.classList.remove('on'); tagFull.classList.add('on'); }
      }
    }
    slider.addEventListener('input', function () { render(+slider.value); });
    render(+slider.value);

    var demoBtn = root.querySelector('[data-demo]');
    if (demoBtn) {
      demoBtn.addEventListener('click', function () {
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var v = +slider.value, dir = 1;
        var iv = setInterval(function () {
          v += dir * 4;
          if (v >= 100) { v = 100; dir = -1; }
          if (v <= 15 && dir < 0) { clearInterval(iv); v = 82; slider.value = v; render(v); return; }
          slider.value = v; render(v);
        }, 28);
      });
    }
  }

  function initQty(wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-minus]');
    var plus = wrap.querySelector('[data-plus]');
    if (!input) return;
    function clamp(v) { v = parseInt(v, 10); if (isNaN(v) || v < 1) v = 1; if (v > 99) v = 99; return v; }
    if (minus) minus.addEventListener('click', function () { input.value = clamp(input.value) - 1 || 1; });
    if (plus) plus.addEventListener('click', function () { input.value = clamp(input.value) + 1; });
    input.addEventListener('change', function () { input.value = clamp(input.value); });
  }

  function initCountdown(el) {
    var mins = parseInt(el.dataset.countdown, 10) || 720; // minutes
    var end = Date.now() + mins * 60000;
    function tick() {
      var d = Math.max(0, end - Date.now());
      var h = Math.floor(d / 3.6e6), m = Math.floor(d % 3.6e6 / 6e4), s = Math.floor(d % 6e4 / 1e3);
      el.textContent = [h, m, s].map(function (n) { return String(n).padStart(2, '0'); }).join(':');
      if (d <= 0) end = Date.now() + mins * 60000;
    }
    tick(); setInterval(tick, 1000);
  }

  var SHADE_HEX = {
    'black': '#1b1a18', 'jet black': '#141312', 'soft black': '#221f1b',
    'dark brown': '#33251b', 'darkest brown': '#2a1e16',
    'brown': '#5a3e28', 'medium brown': '#5a3e28', 'chestnut': '#5a3e28', 'chestnut brown': '#5a3e28',
    'light brown': '#855c39',
    'auburn': '#7a3f2a', 'red': '#7a3f2a', 'ginger': '#9a5a34',
    'grey': '#9a938a', 'gray': '#9a938a', 'ash': '#9a938a', 'salt & pepper': '#8a857c', 'silver': '#b8b2a8', 'white': '#d8d3ca',
    'blonde': '#b98f52', 'blond': '#b98f52', 'dark blonde': '#a07c45'
  };
  function shadeColor(name) { var k = (name || '').toLowerCase().trim(); return SHADE_HEX[k] || '#8a7a5f'; }

  function initVariantPicker(root) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var scope = root.closest('[data-variant-scope]') || document;
    var idInput = scope.querySelector('[data-variant-id]');
    var addBtn = scope.querySelector('[data-add-btn]');
    var priceNow = scope.querySelector('[data-price-now]');
    var priceWas = scope.querySelector('[data-price-was]');
    var pricePct = scope.querySelector('[data-price-pct]');
    var defLabel = addBtn ? (addBtn.getAttribute('data-default-label') || addBtn.textContent) : '';
    var rows = Array.prototype.slice.call(root.querySelectorAll('.r-optrow'));
    var selected = rows.map(function (row) {
      var s = row.querySelector('.r-swatch[aria-pressed="true"]');
      return s ? s.getAttribute('data-opt-value') : null;
    });
    rows.forEach(function (row) {
      if (row.getAttribute('data-swatch-style') === 'color') {
        row.querySelectorAll('.r-swatch').forEach(function (sw) {
          var d = sw.querySelector('.r-dot');
          if (d) d.style.background = shadeColor(sw.getAttribute('data-opt-value'));
        });
      }
    });
    function findVariant() {
      return variants.filter(function (v) {
        return v.options.length === selected.length && v.options.every(function (o, i) { return o === selected[i]; });
      })[0];
    }
    function update() {
      var v = findVariant();
      if (idInput && v) idInput.value = v.id;
      if (priceNow && v) priceNow.textContent = v.price_html;
      if (priceWas) { if (v && v.compare_html) { priceWas.textContent = v.compare_html; priceWas.style.display = ''; } else priceWas.style.display = 'none'; }
      if (pricePct) { if (v && v.pct > 0) { pricePct.textContent = 'SAVE ' + v.pct + '%'; pricePct.style.display = ''; } else pricePct.style.display = 'none'; }
      if (addBtn) {
        if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; addBtn.classList.add('r-soldout'); }
        else if (!v.available) { addBtn.disabled = true; addBtn.textContent = 'Sold out'; addBtn.classList.add('r-soldout'); }
        else { addBtn.disabled = false; addBtn.textContent = defLabel; addBtn.classList.remove('r-soldout'); }
      }
    }
    root.addEventListener('click', function (e) {
      var sw = e.target.closest('.r-swatch'); if (!sw) return;
      var idx = parseInt(sw.getAttribute('data-opt-index'), 10);
      selected[idx] = sw.getAttribute('data-opt-value');
      var row = rows[idx];
      row.querySelectorAll('.r-swatch').forEach(function (x) { x.setAttribute('aria-pressed', x === sw ? 'true' : 'false'); });
      var cur = row.querySelector('[data-opt-current]');
      if (cur) cur.textContent = selected[idx];
      update();
    });
    update();
  }

  function boot() {
    document.querySelectorAll('[data-root-dial]').forEach(function (el) {
      if (!el.dataset.rInit) { el.dataset.rInit = '1'; initDial(el); }
    });
    document.querySelectorAll('[data-qty-wrap]').forEach(function (el) {
      if (!el.dataset.rInit) { el.dataset.rInit = '1'; initQty(el); }
    });
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      if (!el.dataset.rInit) { el.dataset.rInit = '1'; initCountdown(el); }
    });
    document.querySelectorAll('[data-variant-picker]').forEach(function (el) {
      if (!el.dataset.rInit) { el.dataset.rInit = '1'; initVariantPicker(el); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Re-init when merchant edits the section in the Shopify theme editor
  document.addEventListener('shopify:section:load', boot);
})();
